import { gql } from "@apollo/client";

import {
  TICKET_TEMPLATE_FRAGMENT,
  TICKET_TEMPLATE_NODE_FRAGMENT,
} from "./fragments";

export const TICKET_TEMPLATE_CREATE_MUTATION = gql`
  ${TICKET_TEMPLATE_FRAGMENT}
  mutation TicketTemplateCreate($input: TicketTemplateCreateInput!) {
    ticketTemplateCreate(input: $input) {
      ...TicketTemplate
    }
  }
`;

export const TICKET_TEMPLATE_UPDATE_MUTATION = gql`
  ${TICKET_TEMPLATE_NODE_FRAGMENT}
  mutation TicketTemplateUpdate(
    $id: Int!
    $input: TicketTemplateUpdateInput!
    $ticketPoolsSkip: Int
    $ticketPoolsTake: Int
    $ticketPoolsFilters: TicketPoolFilterInput
    $ticketPoolsOrderBy: [TicketPoolOrderByInput!]
    $skipTicketPools: Boolean = false
  ) {
    ticketTemplateUpdate(id: $id, input: $input) {
      ...TicketTemplateNode
    }
  }
`;

export const TICKET_TEMPLATE_DELETE_MUTATION = gql`
  ${TICKET_TEMPLATE_FRAGMENT}
  mutation TicketTemplateDelete($id: Int!) {
    ticketTemplateDelete(id: $id) {
      ...TicketTemplate
    }
  }
`;
